
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useAllOpinionsQuery } from 'components/Opinion/OpinionCol/OpinionCol.hooks';
import { OpinionModel } from 'components/Opinion/Opinion.hooks';
import { OpinionItem } from 'components/Opinion/OpinionItem';
import { ListGroup } from 'react-bootstrap';
import { usePageTitle } from 'routes/Util/Util.hooks';
import { OpinionFilter, OpinionFilterVariables } from 'components/Opinion/OpinionFilter';
import { useCallback, useContext, useState } from 'react';
import ContentLoader from 'react-content-loader';
import { Link } from 'react-router-dom';
import { UserContext } from 'components/UserContext';
import { OpinionInduceRows } from 'components/Opinion/OpinionInduceRows';

export const CommunityPage = () => {
  usePageTitle('아이디어');
  const [params, setParams] = useState<OpinionFilterVariables>({ sort: 'createdAt' });
  const { isLoading: isLoadingUser, user } = useContext(UserContext);
  const { isLoading, data: opinions = [] } = useAllOpinionsQuery(params);
  const onSubmit = useCallback((values) => {
    setParams(values);
  }, []);
  const canRead = user ? user.canReadArticles : false;

  return (
    <Container>
      {!isLoadingUser && !canRead && <OpinionInduceRows />}
      {!isLoadingUser && canRead &&  (
        <Row>
          <Col className="d-flex justify-content-between align-items-center">
            <OpinionFilter onSubmit={onSubmit} />
            <Link className="btn btn-outline-primary" to="/articles/new">작성하기</Link>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          {isLoading ? (
            <ContentLoader viewBox={`0 0 261 228`}>
              {Array.from({ length: 5 }).map((_, i) => (
                <rect key={i} x={0} y={i * 20} rx={4} ry={4} width={261} height={15} />
              ))}
            </ContentLoader>
          ) : (
            <ListGroup>
              {opinions.map((opinion: OpinionModel) => {
                return (
                  <OpinionItem
                    key={opinion.createdAt.toDate().getTime()}
                    canRead={canRead}
                    isShowDirection
                    isShowStock={!!opinion.symbol}
                    {...opinion}
                  />
                );
              })}
            </ListGroup>
          )}
        </Col>
      </Row>
    </Container>
  );
};
